const ProductComponent = function(wish, files, productId, options, share, forRedeem = false) {
    const shareObj = typeof share === 'object' ? share : {};
    return {
        wish : wish,
        showMore: false,
        hasMore: false,
        active: 0,
        xDown : 0,
        yDown : 0,
        files : files,
        quantity : 1,
        forRedeem : forRedeem,
        productNotes : '',
        share : shareObj,
        selectedSlot : null,
        serviceDate : '',
        availableSlots : [],
        loadingSlots : false,
        getOptions : function() {
            const self = this;
            return this.options.filter(function(option) {
                if (option.parent_id) {
                    let parent = self.getParent(option.parent_id);

                    return self.isValid(parent, option.parent_option_id);
                }else {
                    return true;
                }
            });
        },
        product : productId,
        options : (options || []).reduce(function(result, option) {
            option.hasMore = option.options.length >= 5;
            option.showMore = false;
            result.push(option);

            return result;
        }, []),
        loading : {
            'submit' : false,
            'wish' : false,
            'share' : false,
        },
        getParent : function (parent_id) {
            return this.options.find(function (op) {
                return op.id === parent_id;
            });
        },
        getTotalString : function (index = null, plus = 0) {
            let total;

            const optionsReducer = function (r, el) {
                if( el.is_free  || el.quantity == 0) {
                    return  r + 0
                } else {
                    return r + (el.price * el.quantity)
                }
            }

            if (index == null) {
                total = this.options.reduce(function(sum, option) {
                    return option.options.reduce(optionsReducer, sum);
                }, 0);
            } else {
               total = this.options[index].options.reduce(optionsReducer, 0);
            }

            return  'R$ ' + ((total+ plus)/100).toFixed(2);
        },

        loadSlots : async function() {
            if (!this.share || !this.share.is_service || !this.serviceDate) {
                this.availableSlots = [];
                return;
            }
            this.loadingSlots = true;
            this.selectedSlot = null;
            try {
                const url = (this.share.available_slots_url || '') + (this.share.available_slots_url.indexOf('?') >= 0 ? '&' : '?') + 'date=' + encodeURIComponent(this.serviceDate);
                const res = await fetch(url);
                const data = await res.json();
                let slots = data.slots || [];
                // No mesmo dia, exibir apenas horários futuros
                const today = new Date().toISOString().split('T')[0];
                if (this.serviceDate === today) {
                    const now = new Date();
                    slots = slots.filter(function (slot) {
                        return new Date(slot.starts_at) > now;
                    });
                }
                this.availableSlots = slots;
            } catch (e) {
                this.availableSlots = [];
            }
            this.loadingSlots = false;
        },
        isValid : function(option = null, extra_id = null) {
            if (this.share && this.share.is_service) {
                return this.selectedSlot !== null && this.selectedSlot.starts_at && this.selectedSlot.ends_at;
            }
            if (option && extra_id) {
                let extra = option.options.find(function(el){
                    return el.id === extra_id
                });

                return extra && extra.quantity > 0;
            }

            let options = this.getOptions();

            if (options.length == 0) {
                return  true
            }


            return options?.filter(function(op){

                if (!op.required) {
                    return true;
                }

                let min_qty = op.minimum_quantity_options ? parseInt(op.minimum_quantity_options) : 0;
                let max_qty = op.maximum_quantity_options ? parseInt(op.maximum_quantity_options) : 0;
                let total   = op.options.reduce(function(val, el){
                    if (op.is_single) {
                        if (val === 0) {
                            return el.quantity > 0 ? 1 : 0;
                        } else {
                            return el.quantity > 0 ? 2 : 1;
                        }
                    }

                    return val + parseInt(el.quantity);
                }, 0);

                if (op.is_single) {
                    return total === 1;
                }

                return (min_qty === 0 || total >= min_qty) && (max_qty === 0 || total <= max_qty);

            })?.length === options?.length;
        },
        isDisabled : function (op, extra, minus =  true) {
            if (this.options[op].is_single) {
                return  false;
            }
            let max_qty = this.options[op].maximum_quantity_options ? parseInt(this.options[op].maximum_quantity_options) : 0;
            let total   = this.options[op].options.reduce(function(val, el){
                return val + parseInt(el.quantity);
            }, 0);

            if (this.options[op].options[extra].quantity == 0 && minus) {
                return  true
            }

            if (this.options[op].options[extra].quantity == 0 && (max_qty > 0 && total >= max_qty)) {
                return true;
            }

            return (max_qty > 0 && total >= max_qty) && (!minus && this.options[op].options[extra].quantity > 0);
        },
        submit : function() {
            this.loading['submit'] = true;
            const options = this.getOptions().map(function(op){
                return {
                    id : op.id,
                    values : op.options.map(function(el){
                        return {
                            id : el.id,
                            quantity : el.quantity,
                        }
                    })
                }
            });
            const scheduledSlot = (this.share && this.share.is_service && this.selectedSlot) ? this.selectedSlot : null;
            const qty = (this.share && this.share?.is_service && this.options.length === 0) ? 1 : (this.getOptions().length > 0 ? 1 : this.quantity);
            Livewire.emit('add-to-cart', this.product, qty, false, options, this.forRedeem, this.productNotes || null, scheduledSlot)
        },
        handleTouchStart : function ($event) {
            let firstTouch = $event.touches[0];
            this.xDown = firstTouch.clientX;
            this.yDown = firstTouch.clientY;
        },
        handleTouchMove : function ($event) {
            if ( ! this.xDown || ! this.yDown ) {   return;}
            let xUp = $event.touches[0].clientX;
            let yUp = $event.touches[0].clientY;
            let xDiff = this.xDown - xUp;
            let yDiff = this.yDown - yUp;

            if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
                if ( xDiff > 0 ) {
                    this.active = (this.active-1 > 0 ? this.active-1 : 0) % this.files.length;
                } else {
                    this.active = (this.active+1) % this.files.length;
                }
            }

            this.xDown = null;
            this.yDown = null;
        },
        handleExtraChoice : function(extra, option, extraIndex, optionIndex,$event) {
            let currentEl = document.getElementById('extra_' + option.id);

            if (currentEl) {
                currentEl.checked = true;
            }

            if (!$event.target.checked) {
                this.options[extraIndex].options[optionIndex].quantity = 0;
            } else if (extra.is_single || extra.maximum_quantity_options == 1) {
                this.options[extraIndex].options = this.options[extraIndex].options.reduce(function(items, item) {
                    let el = document.getElementById('extra_' + item.id);
                    if (($event?.target?.id !== 'extra_' + item.id) && (item.quantity > 0 || (el && el.checked) )) {
                        item.quantity = 0;
                        el.checked = false;
                    }

                    items.push(item);

                    return items;
                }, []);

                this.options[extraIndex].options[optionIndex].quantity = option.min_qty ?? 1;

                return  false;
            } else {
                let total = extra.options.reduce(function(t,el) {
                    return t + parseInt(el.quantity);
                }, option.min_qty ?? 1);

                let max_qty = extra.maximum_quantity_options ? parseInt(extra.maximum_quantity_options) : 0;

                if (max_qty > 0 && total > max_qty) {
                    $event.preventDefault();
                    $event.stopPropagation();
                    let target = $event.target;
                    if (target.checked) {
                        target.checked = false;
                    }

                    return false;
                }
                this.options[extraIndex].options[optionIndex].quantity = option.min_qty ?? 1;
            }

        },
        handleExtraChoiceNumber : function (extra,option,extraIndex, optionIndex, qty) {

            let total = extra.options.reduce(function(t,el) {
                return t + parseInt(el.quantity);
            },0);


            if (extra.maximum_quantity_options > 0 && qty > 0 && extra.maximum_quantity_options - total <= 0) {
                return false;
            }

            let min_qty = option.min_qty <= 0 ? 1 : option.min_qty;

            qty = qty > 0
                ? min_qty :
                -1* min_qty;

            if (parseInt(this.options[extraIndex].options[optionIndex].quantity) + qty >=  0) {
                this.options[extraIndex].options[optionIndex].quantity = parseInt(this.options[extraIndex].options[optionIndex].quantity) + qty;
            }

        },
        updateData : function (data) {
            this.active = 0
            this.quantity = 1;
            this.loading = {
                'submit': false,
                'wish': false,
                'share': false,
            };

            this.share = data.share_data
            this.wish = data.wish;
            this.files = data.files;
            this.product = data.id;
            this.options = data.options.reduce(function(result, option) {
                option.hasMore = option.options.length >= 5;
                option.showMore = false;
                result.push(option);

                return result;
            }, []);
            this.forRedeem = data.forRedeem;
            this.showMore = false;
            this.hasMore = this.options.length >= 4;
            if (data.share_data) this.share = data.share_data;
            this.selectedSlot = null;
            this.serviceDate = '';
            this.availableSlots = [];
        },
        updateWishList : function () {
            this.loading['wish'] = true;
            Livewire.emitTo('store.cart', 'add-to-favorites', this.product, !this.wish)
        },
        shareProduct : function($event) {
            navigator.share(this.share)
        },
        wishUpdate : function ($event) {
            this.wish = $event.id == this.product ? !this.wish : this.wish;
            this.loading['wish'] = false
        },
        stopLoading : function (field) {
            this.loading[field] = false;
        },
        handleImgError : function ($event) {
            this.files[this.active].src = window.not_found_img_url;
            this.files[this.active].srcset = window.not_found_img_url;
        }
    }
}

export default ProductComponent